import { BasePaginationRespone } from '../../base/BasePaginationRespone';
import { BaseSelectRequest } from '../../base/BaseSelectRequest';
import { BaseShowDetail } from '../../base/BaseShowDetail';
import { BaseAction } from '../../base/IBaseActionRespone';
import { ProductTypeModel } from '../../models/product-type/ProductTypeModel';
import {
	ProductTypeAction_CHANGE_SELECTED_IDS,
	ProductTypeAction_DELETE_Failure,
	ProductTypeAction_DELETE_Request,
	ProductTypeAction_DELETE_Success,
	ProductTypeAction_GETALL_Failure,
	ProductTypeAction_GETALL_Request,
	ProductTypeAction_GETALL_Success,
	ProductTypeAction_GETPAGINATION_Failure,
	ProductTypeAction_GETPAGINATION_Request,
	ProductTypeAction_GETPAGINATION_Success,
	ProductTypeAction_RELOAD,
	ProductTypeAction_SAVE_Failure,
	ProductTypeAction_SAVE_Request,
	ProductTypeAction_SAVE_Success,
	ProductTypeAction_SHOW_CONFIRM,
	ProductTypeAction_SHOW_DETAIL,
	eProductTypeActionTypeIds,
} from './IProductTypeActionsTypes';

export const productTypeActions = {
	//ALL
	getAllRequest: (): ProductTypeAction_GETALL_Request => BaseAction(eProductTypeActionTypeIds.GET_ALL_REQUEST, undefined),
	getAllSuccess: (data: ProductTypeModel[]): ProductTypeAction_GETALL_Success =>
		BaseAction(eProductTypeActionTypeIds.GET_ALL_SUCCESS, data),
	getAllFailure: (error: Error | string): ProductTypeAction_GETALL_Failure => BaseAction(eProductTypeActionTypeIds.GET_ALL_FAILURE, error),
	//LIST
	getPaginationRequest: (request: BaseSelectRequest): ProductTypeAction_GETPAGINATION_Request =>
		BaseAction(eProductTypeActionTypeIds.GET_PAGINATION_REQUEST, request),
	getPaginationSuccess: (data: BasePaginationRespone<ProductTypeModel>): ProductTypeAction_GETPAGINATION_Success =>
		BaseAction(eProductTypeActionTypeIds.GET_PAGINATION_SUCCESS, data),
	getPaginationFailure: (error: Error | string): ProductTypeAction_GETPAGINATION_Failure =>
		BaseAction(eProductTypeActionTypeIds.GET_PAGINATION_FAILURE, error),
	//SAVE
	saveRequest: (entity: ProductTypeModel): ProductTypeAction_SAVE_Request => BaseAction(eProductTypeActionTypeIds.SAVE_REQUEST, entity),
	saveSuccess: (message: string): ProductTypeAction_SAVE_Success => BaseAction(eProductTypeActionTypeIds.SAVE_SUCCESS, message),
	saveFailure: (error: Error | string): ProductTypeAction_SAVE_Failure => BaseAction(eProductTypeActionTypeIds.SAVE_FAILURE, error),
	//DELETE
	deleteRequest: (ids: number[]): ProductTypeAction_DELETE_Request => BaseAction(eProductTypeActionTypeIds.DELETE_REQUEST, ids),
	deleteSuccess: (message: string): ProductTypeAction_DELETE_Success => BaseAction(eProductTypeActionTypeIds.DELETE_SUCCESS, message),
	deleteFailure: (error: Error | string): ProductTypeAction_DELETE_Failure => BaseAction(eProductTypeActionTypeIds.DELETE_FAILURE, error),
	//RELOAD
	needReload: (): ProductTypeAction_RELOAD => BaseAction(eProductTypeActionTypeIds.NEED_RELOAD, undefined),
	//ACTIONs
	changeSelectedIds: (ids: number[]): ProductTypeAction_CHANGE_SELECTED_IDS =>
		BaseAction(eProductTypeActionTypeIds.CHANGE_SELECTED_IDS, ids),
	showDetail: (detail: BaseShowDetail<ProductTypeModel>): ProductTypeAction_SHOW_DETAIL =>
		BaseAction(eProductTypeActionTypeIds.SHOW_DETAIL, detail),
	showConfirm: (show: boolean): ProductTypeAction_SHOW_CONFIRM => BaseAction(eProductTypeActionTypeIds.SHOW_CONFIRM, show),
};
